import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import ActionPlayNbDefault from "@/icons/Action/PlayNb/Default";

import { Icon } from "../Icon";
import GalleryVideoSource from "./GalleryVideoSource";

import styles from "./ModalGallery.scss";

function GalleryVideo({
  children,
  width,
  height,
  fallbackMessage,
  controls,
  ...props
}) {
  const [showCover, setShowCover] = useState(true);
  const videoRef = useRef();

  function handleCoverClick() {
    if (videoRef.current) {
      videoRef.current.focus();
      videoRef.current.play();
      setShowCover(false);
    }
  }

  return (
    <div className={styles["video-container"]}>
      <button
        type="button"
        className={cx(styles["video-cover"], {
          [styles["video-cover--hidden"]]: !showCover,
        })}
        onClick={handleCoverClick}
      >
        <span className={styles["video-icon-wrapper"]}>
          <Icon
            icon={ActionPlayNbDefault}
            color="white"
            size={Icon.Size.parent}
          />
        </span>
      </button>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <video
        ref={videoRef}
        width={width}
        height={height}
        controls={controls}
        {...props}
      >
        {children}
        {fallbackMessage}
      </video>
    </div>
  );
}

GalleryVideo.Source = GalleryVideoSource;

GalleryVideo.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  fallbackMessage: PropTypes.string,
  controls: PropTypes.bool,
};

GalleryVideo.defaultProps = {
  width: "100%",
  height: "100%",
  fallbackMessage: "Dieser Browser unterstützt keine video tags",
  controls: true,
};

GalleryVideo.displayName = "ModalGallery.Video";

export default GalleryVideo;
